<template>
  <div class="search_list">
    <div v-if="nodata">
      <div class="search_item" @click="selectCourse(1)">
        <h4>尚系列之星空</h4>
        <div class="search-content">尚系列名称的含义:“尚”为时尚，“Shine”英音[ʃain]为发光，闪 耀。尚系列表款体现时尚生活、闪耀动人的姿态。时尚是站在潮流浪尖俯 瞰众生的姿态，带给人一种愉悦的心情，展示优雅，赋予人不凡的气质和 神韵，体现精致的生活品味。</div>
        <div class="search_foot">
          <div class="search_foot_left">
            <span style="color:#a0a0a0">观看次数:</span>
            <span class="num">{{num}}次</span>
          </div>
          <div class="search_foot_right">
            <img class="integral_icon" src="../../assets/4@2x.png" alt>
            {{integral}}
          </div>
        </div>
      </div>

      <!-- <div class="search_item" @click="selectCourse(2)">
        <h4>文化底蕴，展示企业魅力</h4>
        <div class="search-content">通过对企业运作模式和经营理念的认识，了解企业的自我定位和价值追求，探索企业发展方向。</div>
        <div class="search_foot">
          <div class="search_foot_left">
            <span style="color:#a0a0a0">观看次数:</span>
            <span class="num">{{num}}次</span>
          </div>
          <div class="search_foot_right">
            <img class="integral_icon" src="../../assets/4@2x.png" alt>
            {{integral}}
          </div>
        </div>
      </div>

      <div class="search_item" @click="selectCourse(3)">
        <h4>文化底蕴，展示企业魅力</h4>
        <div class="search-content">通过对企业运作模式和经营理念的认识，了解企业的自我定位和价值追求，探索企业发展方向。</div>
        <div class="search_foot">
          <div class="search_foot_left">
            <span style="color:#a0a0a0">观看次数:</span>
            <span class="num">{{num}}次</span>
          </div>
          <div class="search_foot_right">
            <img class="integral_icon" src="../../assets/4@2x.png" alt>
            {{integral}}
          </div>
        </div>
      </div>

      <div class="search_item" @click="selectCourse(4)">
        <h4>文化底蕴，展示企业魅力</h4>
        <div class="search-content">通过对企业运作模式和经营理念的认识，了解企业的自我定位和价值追求，探索企业发展方向。</div>
        <div class="search_foot">
          <div class="search_foot_left">
            <span style="color:#a0a0a0">观看次数:</span>
            <span class="num">{{num}}次</span>
          </div>
          <div class="search_foot_right">
            <img class="integral_icon" src="../../assets/4@2x.png" alt>
            {{integral}}
          </div>
        </div>
      </div> -->
    </div>
    <div class="noData" v-if="!nodata">
      <img src="../../assets/49@2x.png" alt="">
      <p class="no_content">当前没有内容</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "search-list-1",
  props:['index'],
  data() {
    return {
      num: 10,
      integral: 10,
      nodata: true
    };
  },
  created(){
    console.log('currentViewIndex',this.index);
    this.$root.center.$on('change_min_tab',data=>{
      if(data==1){
        this.nodata = false;
      } else {
        this.nodata = true
      }
    })
  },
  methods: {
    selectCourse(key) {
      console.log(key);
      this.$router.push({
        path: "/kcxq",
        params: { id: key },
        query: { id: key }
      });
    }
  }
};
</script>

<style>
.search_list {
  width: 100%;
  height: 100%;
}
.search_item {
  background: #ffffff;
  box-shadow: 0 5px 20px 5px rgba(227, 232, 235, 0.75);
  border-radius: 8px;
  width: 100%;
  /* height:165px; */
  margin: auto;
  margin-top: 14px;
}
.search_item:last-child {
  margin-bottom: 15px;
}
.search_item h4 {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  text-align: left;
  display: inline-block;
  padding-top: 20px;
}
.search_item h4::before {
  content: "";
  display: inline-block;
  width: 3px;
  height: 14px;
  margin-right: 15px;
  background-color: #5576ab;
}
.search-content {
  width: 100%;
  padding: 10px 15px 15px 15px;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #a0a0a0;
  letter-spacing: 0;
  line-height: 23px;
  text-align: left;
  border-bottom: 1px solid #e1e6ea;
}
.search_foot {
  font-family: PingFangSC-Regular;
  font-size: 13px;
  line-height: 50px;
  width: 100%;
  display: flex;
  padding: 0 15px;
  justify-content: space-between;
  align-items: center;
}
.num {
  color: #333333;
}
.search_foot_right {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #ffc30b;
  text-align: right;
}
.integral_icon {
  width: 30px;
  height: 30px;
  vertical-align: middle;
}
.noData{
  width: 100%;
  height: 100%;
  padding-top: 20%;
}
.noData>img{
  display: block;
  margin: auto;
  width: 200px;
}
.noData .no_content{
  font-family:PingFangSC-Regular;
  font-size:16px;
  color:#a0a0a0;
  letter-spacing:0;
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/search_item/search_item1.vue